import { _ } from "libs";

import React, { useEffect } from "react";
import LoginForm from "../components/loginForm";
import { History } from "history";
import queryString from "query-string";
import withRedux from "../withRedux";
import { codeLogin } from "../actions";
import Loader from "../components/loader";

type BoxProps = {
	destination?: string;
};

export const LoginBox = ({ destination }: BoxProps) => {
	return (
		<div className="box">
			<div className="boxLeader">
				<h2>{_("loginPage.heading")}</h2>
				<div className="illustration player1" />
			</div>
			<div className="boxContent">
				<LoginForm destination={destination} />
			</div>
		</div>
	);
};

export const SimpleLoginBox = ({ destination }: BoxProps) => {
	return <LoginForm destination={destination} />;
};

const Login = ({ match, history, codeLogin }: { match; history: History; codeLogin }) => {
	const { query } = queryString.parseUrl(history.location.search);

	useEffect(() => {
		if (query["code"]) {
			const code = query["code"];
			codeLogin(code, query["redirect"]).then((res) => {
				if (res.error) {
					history.push("/login");
				}
			});
		}
	}, [query["code"]]);

	//if user comes with an OAuthCode from the former website, show the loading component instead
	if (query["code"]) {
		return <Loader />;
	}

	return (
		<div className="boxWrap">
			<LoginBox />
		</div>
	);
};

const mapStateToProps = () => {
	return {};
};

export default withRedux({ codeLogin }, mapStateToProps)(Login);
